//DAOSection3

// src/components/DAOSection3.js
import React from 'react';
import styled from 'styled-components';

const SectionContainer = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5%; 
  background-color: #000000; /* 调整背景颜色根据需要 */
  width:60%;
  margin: 0 auto;

  @media (max-width: 500px) {
    flex-direction: column; /* 在小于500px时，垂直排列 */
    padding: 5% 0% 0% 0%;
    width:90vw;
  }
`;

const LeftColumn = styled.div`
  flex: 4;
  
  @media (max-width: 500px) {

    width:100%;
    text-align: center;
    
  }
  
`;

const Image = styled.img`
  width: 100%;
  height: auto;
`;



const RightColumn = styled.div`
  flex: 6; 
  width:60%;
  overflow: hidden;
  padding:0% 0% 0% 5%;
  margin-bottom:5%;

  @media (max-width: 500px) {
    
    width:100%;
    padding:0% ;

  }
  
`;

const GroupContainer = styled.div`
  margin-bottom: 2.5%; 
  margin-left: 2.5%; 

  padding:%;

  @media (max-width: 500px) {
    width:100%;
    margin:0 auto;
   
    padding:0% 0% 2% 0%;

  }
`;

const GroupTitle = styled.h3`
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 41px;
  margin-bottom: 5%;
  margin-top: 1%; 
  color: #FFFFFF;
  padding:0% 0% 0% 3%;


  p{

    font-size: 18px;
    line-height: 32px;
    color: #AFAFAF;
  }

  @media (max-width: 500px) {
    font-weight: 500;
    font-size: 18px;
    line-height: 26px;
    padding:5% 0% 0% 2% ;

    p {
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
    }
  }

`;

const Button = styled.a`
  text-decoration: none;
  background-color:transparent;
  color:#FFFFFF;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.05em;

  padding: 12px 40px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 100px;
  margin:2%;


  
  @media (max-width: 500px) {
    font-size: 14px;
    line-height: 24px;
    margin-top:0px;

    padding: 6px 20px;
    


  }

  &:hover {
    background-color:#FFFFFF;
    color:#1f1f1f;
  }
`;

const DAOSection3 = () => {
  return (
    <SectionContainer>
      <LeftColumn>
        <Image src="/images/DAOSec3_1.png" alt="Image Title" />
      </LeftColumn>
      <RightColumn>
        <GroupContainer>
          <GroupTitle>DAO 治理框架分析規劃書 概要<p>借鏡 PDT 理論（Pathetic Dot Theory），從社會規範、科技工具、基礎建設生態系、及法律政策四大面向蒐集彙整國內外分散式自治組織討論、研究及經驗，並整理適合導入臺灣之建議。</p></GroupTitle>
          <Button href="https://drive.google.com/file/d/1xidX3iB00wJq2aXOxSefv6qQGCRnL2UB/view?usp=sharing" target="_blank" style={{ textDecoration: 'none' }}>閱讀更多</Button>
         
        </GroupContainer>
        
      </RightColumn>

    </SectionContainer>
    

  );
};



export default DAOSection3;
